import { customElement } from 'lit/decorators.js';
import { localized } from "@lit/localize";
import { UsosBox } from "./usos-box";
import style from './success-box.scss';

/**
 * Success box information. Registers as alert for accessibility tools.
 */

@customElement('success-box')
@localized()
export class SuccessBox extends UsosBox {
    static override styles = [...UsosBox.styles, style];

    constructor() {
        super();
        const internals = this.attachInternals();
        internals.role = 'alert';
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'success-box': SuccessBox
    }
}
